<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  metaInfo: {
      titleTemplate: '%s Betaenergy.bg',
      htmlAttrs: {
        lang: 'bg'
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'Вашият посредник в енергетиката' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'keywords', content: 'енергия, услуги, покупка, посредник, бета, бетаенерджи, beta, betaenergy' },
        { name: 'author', content: 'Беталогистика ООД' },
      ]
    },

  data: () => ({
    //
    userIP: '',
  }),
  methods: {
    async getUserIP() {
      let request = await axios.get('https://api.ipify.org?format=json')
      console.log('SEX', request)
      if(request != undefined) {
        this.userIP = request.ip
      }
      
    },
  },
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
        if (theme == "true") {
            this.$vuetify.theme.dark = true;
        } else {
            this.$vuetify.theme.dark = false;
        }
    }
    // this.getUserIP()
},
};
</script>

